export default "__VITE_ASSET__CRdKbDLR__"